import React from "react";
import ReactDOM from "react-dom/client";
import Cursor from "react-special-cursor";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <Cursor
  //   color="orange"
  //   borderClassName="cursor_border"
  //   dotClassName="cursor_back"
  // >
  <App />
  // </Cursor>
);
